import { captureException } from "@sentry/browser";
import ym from "react-yandex-metrika";
import { takeLatest } from "redux-saga/effects";
import { getCookie } from "../../helpers/helpers";
// eslint-disable-next-line import/no-cycle
import { ContactApi } from "../../server/agent";

const ymGetClientId = () =>
  new Promise((resolve) => {
    ym("getClientID", (clientId) => resolve(clientId));
  });

const updateYandexClient = async (contactId) => {
  if (!contactId) return;

  try {
    const contactSource = getCookie("BITRIX_SM_REF_SOURSES");
    const clientId = await ymGetClientId();
    const res = await ContactApi.addYandexClientData({
      contactId,
      contactSource,
      clientId,
    });
    if (!res?.result) return;

    const newClientId = res.data;
    ym("setUserID", newClientId);
  } catch (e) {
    captureException(e);
  }
};

const onSetClientId = (action) => {
  const contactId =
    action.type === "SET_CONTACT_ID"
      ? action.payload
      : action.payload?.contactId;
  updateYandexClient(contactId);
};

// eslint-disable-next-line import/no-default-export
export default function* updateYandexClientSaga() {
  yield takeLatest(["SET_AUTH_DATA", "SET_CONTACT_ID"], onSetClientId);
}
